// Auto generated file, do not manually modify!
// com.hotpads.customermanagement.client.listingspotlight.enums.SmartConfigMode

export enum SmartConfigMode {
  ALL_EXCLUDED = 'ALL_EXCLUDED',
  ALL_INCLUDED = 'ALL_INCLUDED',
}

export const SmartConfigMode_values = [SmartConfigMode.ALL_EXCLUDED, SmartConfigMode.ALL_INCLUDED] as const;
